export const fetchWithAuth = async (input: string, init?: RequestInit) => {
    const mutatedInit = { ...init };

    mutatedInit.credentials = "include"; // Ensure credentials are sent with the request
    const response = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + "api" + input, mutatedInit);

    if (!response.ok) {
        // Gérer les erreurs, par exemple, token expiré
        if (response.status === 401) {
            // Rediriger vers la page de connexion ou rafraîchir le token
            window.location.href = '/login';
            throw new Error('Authentification échouée');
        } else {
            throw new Error('Erreur lors de la requête');
        }        
    }

    return response;
};